"use strict";

function registerStateSource(marty, id, stateSourceId, clazz) {
  marty[id] = clazz;
  marty.stateSources[stateSourceId] = clazz;
}

module.exports = registerStateSource;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/core/registerStateSource.js
 ** module id = 58
 ** module chunks = 0
 **/